export function base64url(str: string): string {
    return btoa(str).replace("+", "-").replace("/", "_");
}

export const COLLECTION_GROUP_SEPARATOR = "_####_";
